import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useRef } from "react";

import { useLocalStorage } from "~/utils";

import Navbar from "../navbar";
import Brand from "./brand";
import { UserItemSet } from "./user-item-sets";
import "./sidebar.scss";

const SIDEBAR_MINIMIZED_LOCAL_STORAGE_VARIABLE = "sidebarMinimized";

function Sidebar() {
  const [minimized, setMinimized] = useLocalStorage(
    SIDEBAR_MINIMIZED_LOCAL_STORAGE_VARIABLE,
    true
  );
  const navRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const recalculateToggleButtonPosition = (actualNavRef) => {
    const refNode = navRef.current || actualNavRef;
    if (!refNode) return;

    const buttonRef = toggleButtonRef.current;

    const navRefRect = refNode.getBoundingClientRect();
    const toggleButtonRefRect = buttonRef.getBoundingClientRect();

    const buttonLeft = navRefRect.width - toggleButtonRefRect.width;

    buttonRef.style.position = "fixed";
    buttonRef.style.left = `${buttonLeft}px`;
  };

  return (
    <div className="sidebar__root">
      <button
        type="button"
        className="sidebar__minimize-button"
        onClick={() => setMinimized((v) => !v)}
        ref={toggleButtonRef}
      >
        <div
          className={classNames("sidebar__minimize-icon text-dark", {
            minimized,
          })}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </div>
      </button>

      <nav
        className={classNames("sidebar__paper bg-light px-3", {
          minimized,
        })}
        ref={recalculateToggleButtonPosition}
      >
        <div className="sidebar__content">
          <Brand minimized={minimized} />

          <hr className="mx-0" />

          <div className="sidebar__overflow-section">
            <ul className="nav flex-column">
              <Navbar minimized={minimized} />
            </ul>
          </div>

          <div className="bg-light mt-auto mb-3">
            <hr className="mx-0" />

            <ul className="nav flex-column">
              <UserItemSet minimized={minimized} />
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Sidebar;
